import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function AdminDashboard() {
  const navigate = useNavigate();
  const [relatorios, setRelatorios] = useState([]);
  const [erro, setErro] = useState('');

  useEffect(() => {
    const fetchRelatorios = async () => {
      try {
        const response = await axios.get('http://192.168.40.105:3000/api/admin/relatorios'); // Ajuste para sua API
        setRelatorios(response.data);
      } catch (error) {
        setErro('Erro ao carregar relatórios.');
      }
    };

    fetchRelatorios();
  }, []);

  const handleLogout = () => {
    // Função de logout
    navigate('/');
  };

  return (
    <div className="container mt-5">
      <div className="card p-4 shadow-lg">
        <h1 className="text-center mb-4">Dashboard Administrativo</h1>
        <button className="btn btn-secondary mb-3" onClick={handleLogout}>
          Logout
        </button>

        {erro && <div className="alert alert-danger">{erro}</div>}

        {relatorios.length > 0 ? (
          <ul className="list-group">
            {relatorios.map((relatorio, index) => (
              <li key={index} className="list-group-item">
                <strong>{relatorio.titulo}:</strong> {relatorio.valor}
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhum relatório disponível no momento.</p>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
